<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Empresa:" label-for="input-empresa">
          <b-form-select
            id="input-empresa"
            v-model="vinculoForm.id_empresa_sistema"
            :options="empresasOptionsComputed"
            required
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled
                >Selecione uma Empresa</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
      </div>

      <div class="col-md-4">
        <b-form-group label="Tipo de Plano:" label-for="input-tipo">
          <b-form-select
            id="input-tipo"
            v-model="vinculoForm.tipo_plano"
            :options="tiposDePlano"
            required
            placeholder="Selecione o Tipo de Plano"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>
                Selecione o Tipo de Plano
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </div>

      <div class="col-md-4">
        <b-form-group label="Valor R$:" label-for="input-valor">
          <b-form-input
            id="input-valor"
            type="text"
            v-model.lazy="vinculoForm.valor"
            v-money="money"
            placeholder="Valor do Plano"
          ></b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-4">
        <b-form-group label="Data de Início:" label-for="datepicker-inicio">
          <b-form-datepicker
            id="datepicker-inicio"
            v-model="vinculoForm.data_inicio"
            placeholder="Data de início"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            locale="pt-BR"
            required
          >
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>
      </div>

      <div class="col-12">
        <b-button variant="success" @click.prevent="salvarVinculo"
          >Salvar</b-button
        >
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="true"
    ></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import empresa_sistema from '../services/empresa_sistema'
import vinculoPlano from '../services/vinculo-plano'
import { VMoney } from 'v-money'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

export default {
  components: { Loading, DatePicker },
  directives: {
    money: VMoney,
  },
  props: {
    vinculo: {
      type: Object,
      default: () => ({
        id_empresa_sistema: null,
        valor: '',
        data_inicio: '',
        tipo_plano: null,
      }),
    },
  },
  data() {
    return {
      tiposDePlano: [
        { text: 'Mensal', value: 'Mensal' },
        { text: 'Anual', value: 'Anual' },
        { text: 'Créditos', value: 'Creditos' },
      ],
      vinculoForm: {
        id_empresa_sistema: null,
        valor: '',
        data_inicio: '',
        tipo_plano: null,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      empresasOptions: [],
      isLoading: false,
    }
  },
  computed: {
    empresasOptionsComputed() {
      return this.empresasOptions.map((empresa) => ({
        text: empresa.nome,
        value: empresa.id_empresa_sistema,
      }))
    },
  },
  watch: {
    vinculo: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id_vinculo_plano) {
          this.vinculoForm = { ...newVal }
        }
      },
    },
  },
  mounted() {
    this.carregarEmpresas()
  },
  methods: {
    carregarEmpresas() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      empresa_sistema
        .listarEmpresa(token)
        .then((resposta) => {
          this.empresasOptions = resposta.data.empresa
          this.isLoading = false
        })
        .catch((error) => {
          console.error(error)
          this.empresasOptions = []
          this.isLoading = false
        })
    },
    limparFormularioVinculo() {
      this.vinculoForm = {
        id_empresa_sistema: null,
        valor: '',
        data_inicio: '',
        tipo_plano: null,
      }
    },
    formatarValorParaApi(valor) {
      let valorFormatado = valor
        .replace(/[R$\s]/g, '')
        .replace(/\./g, '')
        .replace(',', '.')

      valorFormatado = parseFloat(valorFormatado)
      valorFormatado = Math.round((valorFormatado + Number.EPSILON) * 100) / 100
      return valorFormatado
    },
    salvarVinculo() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      const vinculoParaEnviar = {
        ...this.vinculoForm,
        valor: this.formatarValorParaApi(this.vinculoForm.valor),
      }

      const acao = vinculoParaEnviar.id_vinculo_plano
        ? vinculoPlano.atualizarVinculo(token, vinculoParaEnviar)
        : vinculoPlano.salvarVinculo(token, vinculoParaEnviar)

      acao
        .then((resposta) => {
          this.isLoading = false
          if (!resposta.data.statusCode || resposta.data.statusCode === 200) {
            this.$bvToast.toast(
              resposta.data.message || 'Operação concluída com sucesso.',
              {
                variant: 'success',
                solid: true,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.limparFormularioVinculo() // Isso reseta o formulário para o estado inicial
          } else {
            this.$bvToast.toast(resposta.data.message || 'Erro na operação.', {
              variant: 'danger',
              solid: true,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          }
        })
        .catch((erro) => {
          this.isLoading = false
          let mensagemErro =
            erro.response && erro.response.data && erro.response.data.message
              ? erro.response.data.message
              : 'Erro desconhecido'
          this.$bvToast.toast(mensagemErro, {
            variant: 'danger',
            solid: true,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },
  },
}
</script>

<style></style>
